export default __webpack_public_path__ + "static/media/arapska-liga-zastava.64b87c83.png";